import _regeneratorRuntime from "/vercel/path0/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { browserHmacSha256Sign, browserHmacSha512Sign } from "../lib/browser";
import { isConstantTime } from "../helpers";
export function hmacSha256Sign(_x, _x2) {
  return _hmacSha256Sign.apply(this, arguments);
}

function _hmacSha256Sign() {
  _hmacSha256Sign = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(key, msg) {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return browserHmacSha256Sign(key, msg);

          case 2:
            result = _context.sent;
            return _context.abrupt("return", result);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _hmacSha256Sign.apply(this, arguments);
}

export function hmacSha256Verify(_x3, _x4, _x5) {
  return _hmacSha256Verify.apply(this, arguments);
}

function _hmacSha256Verify() {
  _hmacSha256Verify = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(key, msg, sig) {
    var expectedSig, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return browserHmacSha256Sign(key, msg);

          case 2:
            expectedSig = _context2.sent;
            result = isConstantTime(expectedSig, sig);
            return _context2.abrupt("return", result);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _hmacSha256Verify.apply(this, arguments);
}

export function hmacSha512Sign(_x6, _x7) {
  return _hmacSha512Sign.apply(this, arguments);
}

function _hmacSha512Sign() {
  _hmacSha512Sign = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(key, msg) {
    var result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return browserHmacSha512Sign(key, msg);

          case 2:
            result = _context3.sent;
            return _context3.abrupt("return", result);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _hmacSha512Sign.apply(this, arguments);
}

export function hmacSha512Verify(_x8, _x9, _x10) {
  return _hmacSha512Verify.apply(this, arguments);
}

function _hmacSha512Verify() {
  _hmacSha512Verify = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(key, msg, sig) {
    var expectedSig, result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return browserHmacSha512Sign(key, msg);

          case 2:
            expectedSig = _context4.sent;
            result = isConstantTime(expectedSig, sig);
            return _context4.abrupt("return", result);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _hmacSha512Verify.apply(this, arguments);
}